import { CustomBadge, FieldBadgeProps } from 'framework/ui/ui-builder';

const PositionSlotPendingConfirmationBadge = (props: FieldBadgeProps) => {
  return <CustomBadge text="Confirmation required" color="warning" {...props} />;
};

export default PositionSlotPendingConfirmationBadge;
